<template lang="pug">
  .products__choosen(:class="`products__choosen_${productItem.code}`")
    .products__choosen-can(v-lazyload)
      img(:src="require(`@/assets/img/products/products_big_can_${productItem.code}.png`)" alt="")
    .products__choosen-info(ref="info")
      .products__choosen-info-content(v-lazyload :class="`products__choosen-info-content_${productItem.code}`")
        .products__choosen-info-top(v-lazyload)
          h2.product__choosen-name {{ productItem.name }}
          div(v-html="productItem.description")
        .products__choosen-info-nutritional(v-if="productItem.nutritional")
          .products__choosen-info-nutritional-content(
            v-html="productItem.nutritional"
            :style="{ maxHeight: `${nutritionalHeight}px` }"
          )
          .products__choosen-info-nutritional-btn(
            :class="{ 'products__choosen-info-nutritional-btn_active': isActive }"
            @click="toggleNutritional"
          )
            span {{ btnTxt }}
        .products__choosen-info-list(v-html="productItem.composition" v-lazyload)
        .products__choosen-info-marketplace(v-if="isGummies") <MarketplaceGummies />
</template>

<script>

import { mapState } from 'vuex'
import MarketplaceGummies from '@/components/marketplaceGummies/MarketplaceGummies.vue'

export default {
  name: 'ProductsItem',
  components: { MarketplaceGummies },
  data: () => ({
    isActive: false
  }),
  computed: {
    ...mapState('products', {
      productItem: state => state.item
    }),
    ...mapState('siteVersions', {
      currentCountry: state => state.item
    }),
    btnTxt () {
      return this.isActive ? this.$t('products.info.collapse') : this.$t('products.info.expand')
    },
    nutritionalHeight () {
      return this.isActive ? this.$refs.info.querySelector('.products__choosen-info-nutritional-content').scrollHeight : 0
    },
    isGummies () {
      return this.productItem.code === 'marmelade'
    }
  },
  methods: {
    toggleNutritional () {
      this.isActive = !this.isActive
    }
  }
}
</script>
